import { useAuthorization } from 'components/Authorization';
import { useLechatAgentEnable } from 'hooks/business/useOrgConfig';

export function useAgentAccess() {
  const enabled = useLechatAgentEnable();
  const { payload } = useAuthorization<Oversea.Token.Payload>();
  return Boolean(enabled && payload?.hasSupervisorPermission === true);
}
